import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { AuthShell } from "@/pages/auth/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [done, setDone] = useState(false);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true); setError("");
        try {
            await api.post("/auth/forgot-password", { email });
            setDone(true);
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
        } finally { setBusy(false); }
    };

    return (
        <AuthShell title="Reset Access" subtitle="We'll send a recovery link if the email is registered.">
            {done ? (
                <div className="space-y-4">
                    <div data-testid="forgot-success" className="rounded-md border border-radioactive/40 bg-radioactive/10 px-3 py-3 text-sm text-radioactive">
                        If that email is registered, a reset link has been sent. Check your inbox.
                    </div>
                    <Link to="/login" className="block text-center text-sm text-hazard hover:underline">Back to sign in</Link>
                </div>
            ) : (
                <form onSubmit={submit} className="space-y-4">
                    {error && <div className="rounded-md border border-danger/40 bg-danger/10 px-3 py-2 text-sm text-danger">{error}</div>}
                    <div>
                        <label className="label-mono text-muted-foreground">Email</label>
                        <Input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                            className="mt-1 bg-background border-border" placeholder="you@outpost.gg" />
                    </div>
                    <Button data-testid="forgot-submit" type="submit" disabled={busy}
                        className="w-full font-heading uppercase tracking-wide bg-hazard text-black hover:bg-hazard/90">
                        {busy ? <Loader2 className="animate-spin" size={16} /> : "Send Reset Link"}
                    </Button>
                    <Link to="/login" className="block text-center text-sm text-muted-foreground hover:text-hazard">Back to sign in</Link>
                </form>
            )}
        </AuthShell>
    );
}
